export const mushroomAttack = new Image();
mushroomAttack.src = "assets/characterSprites/mushroom/Attack.png";
mushroomAttack.width = 1200/8;
mushroomAttack.height = 150/1;
mushroomAttack.yOffset = 38;
mushroomAttack.xOffset = 150;
mushroomAttack.cycleLoop = [0,1,2,3,4,5,6,7];